import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HTTPService } from './services/http.service';
import { SharedService } from './services/shared.service';
import { FooterService } from './footer.service';
import { Subscription, filter } from 'rxjs';
import * as AOS from 'aos';
import { environment } from 'src/environments/environment';
declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [HTTPService]
})
export class AppComponent implements OnInit {
  title = 'PPTToVideoWebAPP';
  isShowLoader: boolean;
  public phone = "971561154655"
  public whatsappTitle = "Help needed from 247Invites";
  public whatsappLink = '';
  public ipStackKey = '';
  public ipAddress = '';
  //showTidioChat: boolean = true;
  showWhatsapp: boolean = true;
  private subscription: Subscription;
  // public paypalClientURL = `https://www.paypal.com/sdk/js?client-id=${environment.paypalClientID}}&intent=capture&locale=en_US&disable-funding=credit,card`;
  public showWhatsappLink = true;
  userDetails: any = {};
  
  ngOnInit() {
    this.isShowLoader = false;
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (this.userDetails?.UserId > 0) {
      this.trackClarityEvent(this.userDetails.Email, this.userDetails.Phone);
    }
    this.footerService.showWhatsapp$.subscribe((value) => {
      this.showWhatsapp = value;
    });
    //AOS.init();
  }
  constructor(private footerService: FooterService, private sharedService: SharedService, private _httpService: HTTPService, private httpClient: HttpClient,
    private activatedRoute: ActivatedRoute, private router: Router, private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) private platformId, private renderer: Renderer2) {

    if (!isPlatformServer(this.platformId)) {
      if ((localStorage.getItem("userlocation") === null || localStorage.getItem("userlocation") === undefined || localStorage.getItem("userlocation") === "null"))
        this.getIP();
      else {
        var currentLocation = localStorage.getItem("userlocation");
        if (JSON.parse(currentLocation).country_code != undefined && JSON.parse(currentLocation).country_code != null) {
          this.sharedService.userCountry = this.getCountry(JSON.parse(currentLocation).country_code);
          this.sharedService.ipAddress = JSON.parse(currentLocation).ip;
          this.sharedService.isUserLocationReset.next(true);
        }
      }
    }
    if (localStorage.getItem("deviceInfo") === null || localStorage.getItem("deviceInfo") === undefined) {
      localStorage.setItem("deviceInfo", JSON.stringify(this.deviceService.getDeviceInfo()));
    }
    this.LoadWhatappNumberDetails();

    this.subscription = this.footerService.showFooter$.subscribe(show => {
      this.showWhatsapp = show;
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pageview',
        page: event.urlAfterRedirects
      });
      gtag('config', 'AW-11006804694');
      console.log("Register Gtag")
    });
    document.documentElement.style.setProperty('--font-base-url', environment.baseURL);

    // this.subscription.add(this.footerService.showTidioChat$.subscribe(show => {
    //   this.showTidioChat = show;
    // }));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrollToTop();
      }
    });
  }
  getCountry(country_code) {
    if (country_code == "IN" || country_code == "AE")
      return country_code
    else
      return "US"
  }
  ngAfterViewInit() {
    this.scrollToTop();
  }
  scrollToTop() {
    setTimeout(() => {
      // Force scroll for all browsers (especially iOS)
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100); // Delay ensures iOS applies scrolling
  }
  LoadWhatappNumberDetails() {
    this.whatsappLink = `https://api.whatsapp.com/send?phone=+918669278777&text=Hi.`;
  }

  getIP() {
    this.httpClient.get(`https://api.ipify.org/?format=json`).subscribe((data: any) => {
      this.ipAddress = data.ip;
      this.getUserLocationDetails(this.ipAddress);
      this.sharedService.ipAddress = data.ip;
    }); // ...using post request
  }
  getUserLocationDetails(ipAddress: string) {
    let objRequestData = Object.assign({});
    objRequestData.ipAddress = ipAddress;
    this._httpService.ajaxPost("HomePage/GetUserLocationDetails", objRequestData).subscribe((data: any) => {
      if (data != undefined || data != "") {
        localStorage.setItem("userlocation", JSON.stringify(data));
        this.sharedService.userCountry = this.getCountry(data.country_code);
        this.sharedService.isUserLocationReset.next(true);
      }
    });
    // this.httpClient.get(`http://ip-api.com/json/${ipAddress}`).subscribe((data: any) => {
    //   data.ipAddress = ipAddress;
    //   localStorage.setItem("userlocation", JSON.stringify(data));
    //   this.sharedService.userCountry = this.getCountry(data.countryCode);
    //   this._httpService.ajaxPost("HomePage/UpdateUserLocationDetails", data).subscribe((data: any) => {
    //   });
    //   this.sharedService.isUserLocationReset.next(true);
    // });
  }
  renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  private trackClarityEvent(email: string, phone: string): void {
    if (window.clarity) {
      try {
        (window as any).clarity("set", "email", email);
        (window as any).clarity("set", "phone", phone);
      } catch (error) {
      }
    } else {
      console.warn("Clarity is not available.");
    }
  }
}
